import React, { useState, useEffect, useRef } from 'react';
import { useQuery } from 'react-apollo';
import ReactImageFallback from 'react-image-fallback';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import ReactTooltip from 'react-tooltip';
import { UncontrolledCollapse } from 'reactstrap';
import {
  capitalizeEveryWord, FALLBACK_ICON, OFFER_DETAIL_LISTING, formatedCurrency, NUMERIC_VALUE,
} from '../../../../utils';
import { GET_OFFER_PARTICIPATING_ARTIST } from '../../../../graphql-client/queries';

function ParticipatingArtistList(props) {
  const {
    participatingData, loading, loadMoreData, offerId, searchKey, listingCount, setShowMessageModal, setMessageModalObj, hasUnreadMessage, messageModalObj,
  } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [defaultResults, setDefaultResults] = useState([]);
  const [filterResults, setfilterResults] = useState([]);
  const [collapseContractClass, setContractCollapseClass] = useState(true);
  const chatWindowRef = useRef();

  const displayMessageModal = (artistDetail) => {
    setShowMessageModal(true);
    setMessageModalObj({ artistDetail: [artistDetail], offerId });
  };

  useEffect(() => {
    chatWindowRef && chatWindowRef.current && chatWindowRef.current.click();
  }, []);

  useEffect(() => {
    if (participatingData && participatingData.data && participatingData.data.length > 0) {
      const dataList = participatingData.data;
      const list = currentPage === NUMERIC_VALUE.ONE ? dataList : defaultResults.concat(dataList);
      setDefaultResults(list);
      setfilterResults(list);
      listingCount(OFFER_DETAIL_LISTING.PARTICIPATING_ARTIST, dataList.length);
    } else if (participatingData && participatingData.count !== 0 && participatingData.data.length === 0) {
      setDefaultResults([]);
    }
  }, [participatingData?.data]);

  useEffect(() => {
    if (searchKey !== null) {
      const lowercasedFilter = searchKey.toLowerCase();
      const filteredData = defaultResults.filter((elem) => elem.userId.name
        && (elem.userId.name.toLowerCase().includes(lowercasedFilter)));
      setfilterResults(filteredData);
    }
  }, [searchKey]);

  const renderParticipatingArtist = () => {
    if (filterResults.length > 0) {
      return map(filterResults, (item) => {
        const {
          basePrice, timeLine, isNotification,
          userId: {
            artistImage, name, _id, email, managerId,
          },
        } = item;
        const managerEmail = managerId && managerId.email;
        return item && (
          <div
            key={`${artistImage}`}
            className={`request-row recommended ${messageModalObj && messageModalObj.artistDetail[0]._id === _id ? 'active' : ''}`}
            onClick={() => displayMessageModal({
              artistImage, name, _id, basePrice, timeLine, isNotification,
            })}
          >
            <div className="image">
              <ReactImageFallback
                src={artistImage}
                fallbackImage={FALLBACK_ICON}
                className="image-cover"
                alt="artist"
              />
            </div>
            <div className="detail">
              <h4
                className="user-name"
                data-tip={email || managerEmail}
                data-place="bottom"
                data-background-color="#fff"
                data-text-color="#000"
              >
                {capitalizeEveryWord(name)}
              </h4>
              <ReactTooltip effect="solid" />
              <p>
                $
                {formatedCurrency(basePrice)}
                {isNotification ? <em className="request-type">New</em> : null }
              </p>
              <span
                className={`icon icon-message ${hasUnreadMessage(_id)
                  && 'unread'}`}
              />
            </div>
          </div>
        );
      });
    }
    return null;
  };

  const handleLoadMoreData = () => {
    const pageNumber = currentPage + NUMERIC_VALUE.ONE;
    setCurrentPage(pageNumber);
    loadMoreData(pageNumber);
  };

  return (
    <>
      <div className="recommended-artist">
        <span
          ref={chatWindowRef}
          id="participatingArtist"
          className={`collapse-head ${collapseContractClass ? 'collapsed' : ''}`}
          onClick={() => { setContractCollapseClass(!collapseContractClass); }}
        >
          Participating Artist (
          {participatingData?.count}
          )
        </span>
        <UncontrolledCollapse toggler="#participatingArtist">
          {renderParticipatingArtist()}
          {(participatingData?.hasNextData) && (
          <div className="request-row recommended">
            <div className="detail">
              <h4
                className="user-name"
                data-place="bottom"
                data-background-color="#fff"
                data-text-color="#000"
              >
                <u onClick={() => !loading && handleLoadMoreData()}>Load More</u>
              </h4>
            </div>
          </div>
          )}
        </UncontrolledCollapse>
      </div>
    </>
  );
}

ParticipatingArtistList.propTypes = {
  offerId: PropTypes.string.isRequired,
  searchKey: PropTypes.string,
  listingCount: PropTypes.func.isRequired,
  setShowMessageModal: PropTypes.func.isRequired,
  setMessageModalObj: PropTypes.func.isRequired,
  hasUnreadMessage: PropTypes.func.isRequired,
  messageModalObj: PropTypes.object,
};

ParticipatingArtistList.defaultProps = {
  searchKey: '',
  messageModalObj: null,
};

export default React.memo(ParticipatingArtistList);
